import { restHeartClient } from '..'

/**
 * 删除文件。
 * @param db
 * @param collection
 * @param fileId
 */
export function deleteFile(db: string, collection: string, fileId: string) {
	return restHeartClient.delete(`${db}/${collection}.files/${fileId}`)
}
